import { styled, Typography } from '@material-ui/core';

export const DataSheetSection = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  alignItems: 'center',
  marginTop: theme.spacing(1.5),
  marginBottom: theme.spacing(4),

  '& .dataSheetButton': {
    display: 'block',
    whiteSpace: 'nowrap',
    margin: 'unset'
  },

  '& .MuiTypography-subtitle1': {
    fontSize: `${theme.typography.pxToRem(16)} !important`,
    whiteSpace: 'break-spaces'
  },

  '& [class*="hintContainer"]': {
    alignItems: 'start',

    '& svg': {
      marginTop: theme.spacing(0.5)
    }
  }
}));

export const DataSheetCardHeading = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));

export const DataSheetTitle = styled(Typography)({
  display: 'flex',
  margin: 'unset'
});
